<template>
  <div>
    <loading
      :active.sync="loading.app"
      :can-cancel="false"
      :is-full-page="true"
      :color="'#0B8BCC'"
      :loader="'dots'"
      :opacity="0.7"
      :lock-scroll="true"
    ></loading>
    <Toast
      :show.sync="toast.show"
      :message="toast.message"
      :tipe="toast.tipe"
      @close="toast.show = false"
      :position="toast.position"
      :icon="toast.icon"
    ></Toast>
    <!-- App Header -->
    <div class="appHeader bg-primary text-light shadow-header-footer">
      <div class="left">
        <router-link :to="{ name: 'account.pin' }" class="headerButton">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </router-link>
      </div>
      <div class="pageTitle">
        PIN Keamanan
      </div>
    </div>
    <!-- * App Header -->

    <div id="appCapsule">
      <!-- Pilih Metode Pengiriman Kode Verifikasi -->
      <div>
        <div class="section m-2 p-2">
          <div class="text-center">
            <h4>Masukkan Kode PIN</h4>
          </div>
        </div>
        <div class="section mb-5 p-2">
          <div class="pin-container mb-5">
            <input
              ref="pin"
              type="number"
              name="pin-code"
              class="pin-input"
              pattern="\d*"
              maxlength="6"
              inputMode="numeric"
              autocomplete="off"
              v-model="auth_data.pin"
              @input="submitLoginVerify()"
              autofocus
            />
          </div>
          <div class="text-center">
            <router-link
              :to="{
                name: 'auth.otp.verify',
                params: {
                  type_reference: 'FORGET_PIN_VERIFY',
                  phonenumber_reference: this.auth_data.phone,
                  target_reference: 'auth.forget',
                  back_reference: 'auth.login',
                  url_reference: '/auth/forget',
                  data_reference: { phone: auth_data.phone },
                },
              }"
              style="font-weight: bold;"
            >
              Lupa Kode PIN?
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "auth.login.pin",
  props: ["back_reference"],
  data() {
    return {};
  },
  created() {
    setTimeout(() => {
      this.$store.commit("SET_LOADING", { app: false });
    }, 500);
  },
  computed: {
    ...mapState(["loading", "toast"]),
    ...mapState("auth", {
      auth_data: (state) => state.auth_data,
    }),
  },
  methods: {
    ...mapActions("auth", ["loginVerify"]),
    submitLoginVerify() {
      if (this.auth_data.pin.length == 6) {
        this.$store.commit("SET_LOADING", { app: true });
        this.loginVerify()
          .then((response) => {
            this.$store.commit("SET_LOADING", { app: false });
            if (this.isAuth) {
              this.$router.push({
                name: "home",
                query: { session_id: response.session_id },
              });
            } else {
              this.$router.push({ name: "auth.login" });
            }
          })
          .catch((error) => {
            this.$store.commit("SET_LOADING", { app: false });
            // console.log(error);
            if (error.status == 400) {
              if (error.data.code == "ACCOUNT_MAX_REQ") {
                this.$store.commit("SET_TOAST", {
                  show: true,
                  message: error.data.message,
                  tipe: "default",
                  icon: "danger",
                });
                // this.$router.push({ name: "auth.login" });
              } else if (error.data.code == "ACCOUNT_NEED_OTP") {
                this.$router.push({
                  name: "auth.otp.verify",
                  params: {
                    data_reference: this.auth_data,
                    url_reference: "/auth/login/verify/otp",
                    type_reference: "LOGIN",
                    target_reference: "home",
                    back_reference: "auth.login",
                    phonenumber_reference: this.auth_data.phone,
                  },
                });
              } else {
                this.$store.commit("SET_TOAST", {
                  show: true,
                  message: error.data.message,
                  tipe: "default",
                  icon: "danger",
                });
              }
            }
          });
      }
    },
  },
  mounted() {
    this.$refs.pin.focus();
    if (this.back_reference == undefined) {
      this.$router.push({
        name: "auth.login",
      });
    }
    // console.log();
    document.body.classList.add("bg-white");
  },
  destroyed() {
    this.$store.commit("RESET_LOADING");
    // this.$store.commit("RESET_TOAST");
  },
};
</script>
